export class InvalidCredentialsException extends Error {}
